"use client";

import { createContext, useContext } from "react";
import type { RouterOutput } from "@/lib/trpc-client";

export type CreatorPortalAccess = { orgSlug?: string };
export type CreatorAccount = RouterOutput["creatorAuth"]["me"];
export const CreatorAuthContext = createContext<{
  account?: CreatorAccount;
  signOut?: () => Promise<void>;
}>({});

export const useCreatorAuth = () => useContext(CreatorAuthContext);
